<template>
    <div id="app" @mouseover="timeTest">
        <transition name="slide">
            <router-view></router-view>
        </transition>
    </div>
</template>
<script>
import { getToken,removeToken } from "@/utils/auth.js"
export default {
    name: "APP",
    created() {
        console.log("加载地区缓存!!")
        this.$store.dispatch("area/load")
    },
    data() {
        return {
            lastTime: null, // 最后一次点击的时间
            currentTime: null, // 当前点击的时间
            timeOut: 60* 60 * 1000 // 设置超时时间:n分钟
        }
    },
    mounted() {
        this.lastTime = new Date().getTime(); 
    },
    methods: {
        timeTest() {
            this.currentTime = new Date().getTime() // 记录这次点击的时间
            if (this.currentTime - this.lastTime > this.timeOut) {
                // 判断上次最后一次点击的时间和这次点击的时间间隔是否大于30分钟
                if (getToken()) {
                    // 如果是登录状态
                    removeToken()
                    this.$message.error('超过30分钟未操作');
                    this.$router.push({ name: "login" });
                    
                } else {
                    this.lastTime = new Date().getTime()
                }
            } else {
                this.lastTime = new Date().getTime() // 如果在30分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
            }
        }
    }
}
</script>
<style lang="scss" scoped>
/*每个页面公共css */
@import url("assets/styles/iconfont.css");
@import "assets/styles/main.scss";
</style>
